export const RE_FLITCHING_DONE_REQUEST = "RE_FLITCHING_DONE_REQUEST";
export const RE_FLITCHING_DONE_SUCCESS = "RE_FLITCHING_DONE_SUCCESS";
export const RE_FLITCHING_DONE_FAILED = "RE_FLITCHING_DONE_FAILED";
